import client from "./client";

export async function me() {
  const { data } = await client.get("/me");
  return data;
}
export async function listDrafts() {
  const { data } = await client.get("/comment_drafts");
  return data.pending || [];
}
export async function approveDraft(id, text, force = false) {
  const { data } = await client.post(`/comment_drafts/${id}/approve`, { text, force });
  return data;
}
export async function rejectDraft(id) {
  const { data } = await client.post(`/comment_drafts/${id}/reject`);
  return data;
}

// --- Admin: user allowlist ---
export async function listUsers() {
  const { data } = await client.get("/users");
  return data.users || [];
}
export async function createUser(payload) {
  const { data } = await client.post("/users", payload);
  return data;
}
export async function updateUser(id, payload) {
  const { data } = await client.patch(`/users/${id}`, payload);
  return data;
}
export async function deleteUser(id) {
  const { data } = await client.delete(`/users/${id}`);
  return data;
}
